
import {Component, Prop, Vue} from 'vue-property-decorator';
import ContactForm from '@/components/ContactForm.vue';

@Component({
    components: { ContactForm },
})
export default class GetInTouch extends Vue {
    private name = '';
}
